import axios from 'axios'
import {API_CONFIG} from './config'
import store from '../store/store';
import router from "@/router/index";
import routeName from '@/router/routeNames.js'


const http = axios.create({
  baseURL: API_CONFIG.API_URL,
  headers: {
    /*"Content-Type": "application/json",*/
  }
})


http.interceptors.request.use(
  config => {
    config.headers.Authorization = store.getters['auth/getToken'] !== '' ? 'Bearer ' + store.getters['auth/getToken'] : ''
    return config
  }, error => Promise.reject(error))

http.interceptors.response.use((response) => {
    return response.data
  },
  error => {

    if(error.response.status === 403){
      router.replace({name: routeName.RN_PUBLIC_QUALIFICATION_DATA})
    }
    return Promise.reject(error)
  }
)

export default http
